import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./AddOns.css";

const AddOns = ({ basePrice, onUpdateTotal }) => {
  const { t } = useTranslation();
  const [selectedAddOns, setSelectedAddOns] = useState([]);

  // ✅ Define the available add-ons with their translation keys
  const addOnsList = [
    { key: "logo", name: t("pricing.addons.logo"), price: 49 },
    { key: "email", name: t("pricing.addons.email"), price: 39 },
    { key: "seo", name: t("pricing.addons.seo"), price: 99 },
    { key: "social", name: t("pricing.addons.social"), price: 59 },
  ];

  // ✅ Toggle selection of add-ons
  const toggleAddOn = (addonKey) => {
    setSelectedAddOns((prev) =>
      prev.includes(addonKey)
        ? prev.filter((key) => key !== addonKey)
        : [...prev, addonKey]
    );
  };

  // ✅ Calculate total price whenever selected add-ons change
  useEffect(() => {
    const selectedAddOnsTotal = addOnsList
      .filter((addon) => selectedAddOns.includes(addon.key))
      .reduce((sum, addon) => sum + addon.price, 0);
    
    const newTotal = basePrice + selectedAddOnsTotal;
    onUpdateTotal(newTotal);  // Send updated price to parent component
  }, [selectedAddOns, basePrice, onUpdateTotal]);

  return (
    <div className="addons-container">
      <h2>{t("pricing.addons_title")}</h2>
      <div className="addons-list">
        {addOnsList.map((addon, index) => (
          <div
            key={index}
            className={`addon-item ${selectedAddOns.includes(addon.key) ? "selected" : ""}`}
            onClick={() => toggleAddOn(addon.key)}
          >
            <span>{addon.name}</span>
            <span>${addon.price}</span>
          </div>
        ))}
      </div>

      {/* ✅ Show selected add-ons summary */}
      <div className="addons-summary">
        <h3>{t("pricing.total")}: ${basePrice + addOnsList
          .filter((addon) => selectedAddOns.includes(addon.key))
          .reduce((sum, addon) => sum + addon.price, 0)}
        </h3>
      </div>
    </div>
  );
};

export default AddOns;